import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'
import { useUserStore } from '../stores/user-store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'App',
    path: '/',
    beforeEnter: (to, from, next) => {
      const lData = localStorage.getItem('__user')
      const uToken = localStorage.getItem('__token')
      if (lData && uToken) {
        next()
      } else {
        return next('/auth')
      }
    },
    component: AppLayout,
    redirect: { name: 'Cotizaciones' },
    children: [
      {
        name: 'Dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'Configuracion',
        path: 'settings',
        beforeEnter: (to, from, next) => {
          const user = useUserStore()
          if (user.can_edit) {
            next()
          } else {
            return next('/dashboard')
          }
        },
        component: () => import('../pages/settings/Settings.vue'),
        redirect: { name: 'General' },
        children: [
          {
            name: 'General',
            path: 'general',
            component: () => import('../pages/settings/General.vue'),
          },
          {
            name: 'Maestros',
            path: 'masters',
            component: () => import('../pages/settings/Masters.vue'),
          },
          {
            name: 'Maestro de vehiculos',
            path: 'vehicles',
            component: () => import('../pages/settings/Vehicles.vue'),
          },
          {
            name: 'Usuarios',
            path: 'users',
            component: () => import('../pages/settings/Users.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Contactos',
        path: 'contacts',
        component: () => import('../pages/customers/CustomersPage.vue'),
        children: [
          {
            name: 'Contactos',
            path: 'list',
            component: () => import('../pages/customers/pages/ListCustomers.vue'),
          },
          {
            name: 'Archivados',
            path: 'locked',
            component: () => import('../pages/customers/pages/ListArchives.vue'),
          },
          {
            name: 'Empresas',
            path: 'juridics',
            component: () => import('../pages/customers/pages/ListCompanies.vue'),
          },
        ],
      },
      {
        name: 'Modulo de cotizaciones',
        path: 'oportunities',
        component: () => import('../pages/oportunities/OportunitiesPage.vue'),
        redirect: { name: 'Listado de cotizaciones' },
        children: [
          {
            name: 'Cotizaciones',
            path: 'list',
            component: () => import('../pages/oportunities/pages/ListOportunities.vue'),
          },
          {
            name: 'oportunities.new',
            path: 'new',
            component: () => import('../pages/oportunities/pages/NewOportunity.vue'),
          },
        ],
      },
      {
        name: 'Modulo de ordenes',
        path: 'orders',
        component: () => import('../pages/orders/OrdersPage.vue'),
        redirect: { name: 'Ordenes de trabajo' },
        children: [
          {
            name: 'Ordenes de trabajo',
            path: 'list',
            component: () => import('../pages/orders/pages/ListOrders.vue'),
          },
          {
            name: 'Detalle de orden',
            path: 'view/:id',
            component: () => import('../pages/orders/pages/ViewOrder.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Empleados',
        path: 'employees',
        component: () => import('../pages/employees/Employees.vue'),
        redirect: { name: 'Personal' },
        children: [
          {
            name: 'Personal',
            path: 'list',
            component: () => import('../pages/employees/pages/ListEmployees.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Flota',
        path: 'fleet',
        component: () => import('../pages/fleet/Fleet.vue'),
        redirect: { name: 'Flota' },
        children: [
          {
            name: 'Flota',
            path: 'list',
            component: () => import('../pages/fleet/pages/ListVehicles.vue'),
          },
          {
            name: 'Soat',
            path: 'soat',
            component: () => import('../pages/fleet/pages/Soat.vue'),
          },
          {
            name: 'Mantenimiento',
            path: 'mainentance',
            component: () => import('../pages/fleet/pages/Mainentance.vue'),
          },
          {
            name: 'Impuestos',
            path: 'taxes',
            component: () => import('../pages/fleet/pages/Taxes.vue'),
          },
          {
            name: 'Multas',
            path: 'fines',
            component: () => import('../pages/fleet/pages/Fines.vue'),
          },
          {
            name: 'Conductores',
            path: 'drivers',
            component: () => import('../pages/fleet/pages/Drivers.vue'),
          },
          {
            name: 'Talleres',
            path: 'mechanics',
            component: () => import('../pages/fleet/pages/Mechanics.vue'),
          },
          {
            name: 'Conductores',
            path: 'drivers',
            component: () => import('../pages/fleet/pages/Drivers.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Combustible',
        path: 'fuel',
        component: () => import('../pages/fuels/Fuel.vue'),
        redirect: { name: 'Combustible' },
        children: [
          {
            name: 'Combustible',
            path: 'list',
            component: () => import('../pages/fuels/pages/ListFuels.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Maestros',
        path: 'masters',
        component: () => import('../pages/masters/Masters.vue'),
        redirect: { name: 'Maestros' },
        children: [
          {
            name: 'Maestros',
            path: 'list',
            component: () => import('../pages/masters/pages/ListMasters.vue'),
          },
        ],
      },
      {
        name: 'Modulo de Contratos',
        path: 'contracts',
        component: () => import('../pages/contracts/ContractsPage.vue'),
        children: [
          {
            name: 'contracts.list',
            path: 'list',
            component: () => import('../pages/contracts/pages/ListContracts.vue'),
          },
          {
            name: 'contracts.types',
            path: 'types',
            component: () => import('../pages/contracts/pages/ListTypeContracts.vue'),
          },
          {
            name: 'contracts.allArchivedContracts',
            path: 'archived',
            component: () => import('../pages/contracts/pages/ListArchivedContracts.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    beforeEnter: (to, from, next) => {
      const lData = localStorage.getItem('__user')
      const uToken = localStorage.getItem('__token')
      if (lData && uToken) {
        return next('/dashboard')
      } else {
        return next()
      }
    },
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'recover',
        path: 'recover-password',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
